import { styled } from '@material-ui/core/styles';
import FPHtmlViewer from 'UI/components/atoms/FPHtmlViewer';

export const FooterActionText = styled(FPHtmlViewer)({
  fontSize: 'inherit',
  fontWeight: 400,
  opacity: 0.6
});
